<template>
  <div class="flex flex-col gap-5">
    <label class="text-lg font-bold">Trending Searches</label>
    <div class="flex flex-wrap gap-3">
      <UBadge color="gray" variant="solid" size="lg" class="cursor-pointer" :icon="item.icon" :label="item.label" v-for="(item, index) in trendingSearches" :key="index" @click="handleNavigation(item)"></UBadge>
    </div>
  </div>
</template>

<script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const { gtag } = useGtag();
const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  const userData = isAuthenticated ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  } : {
    user_name: null,
    user_phone: null,
    user_email: null
  };
  
const trendingSearches = computed(() => {
  return [
    { name: 'Biryani', href: '/shop/fandb' },
    { name: 'Pizza', href: '/shop/fandb' },
    { name: 'Earphones', href: '/shop/electronics' },
    { name: 'Skincare', href: '/shop/bpc' },
    { name: 'Kitchen containers', href: '/shop/handk' },
    { name: 'Formal Shoes', href: '/shop/fashion' },
    { name: 'Grooming', href: '/shop/fashion' }
  ].slice(0, 10).map((item) => ({
    icon: 'i-ph-trend-up',
    label: item.name,
    href: item.href
  }));
});

const handleNavigation = async (item) => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'trending searches',
    [EventParameter.SEARCH_QUERY]: item.name,
  });
  const url = new URL(item.href, window.location.origin);
  const query = Object.fromEntries(url.searchParams.entries());
  await navigateTo({ path: item.href, query });
  return;
}
</script>